import EmptyPlaceholder from './EmptyPlaceholder';

export default EmptyPlaceholder;
